// Scanner feedback, synthesised rather than shipped as an audio file: no asset to
// load, nothing to fail on a slow counter connection, and it works offline.
//
// Browsers refuse audio until the page has been interacted with. At a till the
// first scan IS an interaction (the scanner types into the box), so the context
// is created lazily on the first beep and resumed if the browser suspended it.

let ctx = null;
const audio = () => {
  if (ctx) return ctx;
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  try { ctx = new Ctor(); } catch { ctx = null; }
  return ctx;
};

const KEY = 'erp_beep_muted';
export const isMuted = () => {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
};
export const setMuted = (m) => {
  try { localStorage.setItem(KEY, m ? '1' : '0'); } catch { /* private mode — silence is per-session then */ }
};

// One short tone. Sine at a low gain: audible across a counter, not piercing
// after four hundred bills.
function tone({ freq = 880, ms = 90, gain = 0.06, type = 'sine', delay = 0 } = {}) {
  const ac = audio();
  if (!ac) return;
  if (ac.state === 'suspended') ac.resume().catch(() => {});
  const t0 = ac.currentTime + delay;
  const osc = ac.createOscillator();
  const vol = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  // Ramp the edges — a square-cut tone clicks.
  vol.gain.setValueAtTime(0.0001, t0);
  vol.gain.exponentialRampToValueAtTime(gain, t0 + 0.012);
  vol.gain.exponentialRampToValueAtTime(0.0001, t0 + ms / 1000);
  osc.connect(vol).connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + ms / 1000 + 0.02);
}

// Item added to the bill.
export const beep = () => { if (!isMuted()) tone({ freq: 1046, ms: 80 }); };

// Nothing matched what was scanned — lower, two-part, obviously not a success.
export const errorBeep = () => {
  if (isMuted()) return;
  tone({ freq: 320, ms: 110, type: 'triangle', gain: 0.07 });
  tone({ freq: 220, ms: 150, type: 'triangle', gain: 0.07, delay: 0.1 });
};
